import React, { useState, useEffect } from 'react';
import { GlobalStyle, Box, Goals, Bod} from './style';
import Axios from 'axios';
import Nav from './Nav';
import Foot from './foot';
import Home from './home';
import Board from './board';
import Dice from './Dice';
import Mission from  './mission';
import Missing from './missing';
import Bean from './Bean';
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";



function Body(){

const [count, setCount] = useState(
    +localStorage.getItem('nudes') 
);

const [current, setCurrent] = useState('goals.jpg')

// load #1 MEME TO BE MAIN IMAGE
useEffect(() => {
    document.title = `You have seen tain nude ${count} times`
    Axios.get('http://memerepository.asuscomm.com/api').then(response => {
    let data = response.data[0].image
    setCurrent(`http://memerepository.asuscomm.com/${data}`)
} )

},[current, count])

function nudeHandler(){
    setCount(count + 1)
    localStorage.setItem('nudes', count + 1);
    window.location.assign('http://memerepository.asuscomm.com/10')
}

    return(
        <Bod>
        <Bean />
       
            <Router>
                <Nav />
        {/* COLIN IS GOING TO MURDER ME */}
        {/* IF I DIE COLIN WHITTINGTON DID IT  */}
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/message" component={Board} />
                    <Route exact path="/mission-statement" component={Mission} />
                    <Route exact path="/missing-statement" component={Missing} />
                    <Route exact path="/dice-roll" component={Dice} />
                </Switch>
            </Router>
    </Bod>
    )
}

export default Body;